import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/store'
import { getToken } from '@/utils/auth'
import staticRoutes from './staticRoutes'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: staticRoutes
})

const whiteList = ['/login']

// 防止 next({ ...to, replace: true }) 重复触发
let routeLoaded = false

router.beforeEach(async (to, from, next) => {
  NProgress.start()

  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      const hasUserId = store.getters.userId
      if (hasUserId) {
        next()
      } else {
        try {
          const userInfo = await store.dispatch('user/getUserInfo')
          const accessRoutes = await store.dispatch('permission/generateRoutes', userInfo.permissions || [])
          accessRoutes.forEach(route => {
            router.addRoute(route)
          })
          // 添加404兜底路由
          router.addRoute({ path: '*', redirect: '/dashboard' })
          routeLoaded = true
          next({ ...to, replace: true })
        } catch (error) {
          routeLoaded = false
          await store.dispatch('user/clearUser')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    routeLoaded = false
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})

export default router
